import { SVGProps } from "react";

type QuestionWithCircleProps = SVGProps<SVGSVGElement>;

export const QuestionWithCircle = (props: QuestionWithCircleProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6546_26283)">
      <path
        d="M8 14C6.81331 14 5.65328 13.6481 4.66658 12.9888C3.67989 12.3295 2.91085 11.3925 2.45673 10.2961C2.0026 9.19975 1.88378 7.99335 2.11529 6.82946C2.3468 5.66558 2.91825 4.59648 3.75736 3.75736C4.59648 2.91825 5.66558 2.3468 6.82946 2.11529C7.99335 1.88378 9.19975 2.0026 10.2961 2.45673C11.3925 2.91085 12.3295 3.67989 12.9888 4.66658C13.6481 5.65328 14 6.81331 14 8C13.9983 9.59077 13.3656 11.1159 12.2407 12.2407C11.1159 13.3656 9.59077 13.9983 8 14ZM8 3C7.0111 3 6.0444 3.29325 5.22215 3.84265C4.39991 4.39206 3.75904 5.17296 3.38061 6.08659C3.00217 7.00022 2.90315 8.00555 3.09608 8.97545C3.289 9.94536 3.76521 10.8363 4.46447 11.5355C5.16373 12.2348 6.05465 12.711 7.02455 12.9039C7.99446 13.0969 8.99979 12.9978 9.91342 12.6194C10.8271 12.241 11.6079 11.6001 12.1574 10.7779C12.7068 9.95561 13 8.98891 13 8C12.9985 6.67437 12.4713 5.40344 11.5339 4.46608C10.5966 3.52871 9.32564 3.00146 8 3Z"
        fill="currentColor"
      />
      <path
        d="M8.49975 9.49978H7.49975V9.12828C7.49237 8.77549 7.57954 8.42716 7.75222 8.11943C7.92489 7.8117 8.17679 7.5558 8.48175 7.37828C8.66649 7.27653 8.81433 7.11898 8.90413 6.92815C8.99393 6.73732 9.0211 6.52298 8.98175 6.31578C8.94279 6.11838 8.84587 5.93708 8.70338 5.79503C8.56088 5.65297 8.37927 5.55662 8.18175 5.51828C8.03761 5.4916 7.88937 5.49694 7.74752 5.53391C7.60567 5.57089 7.47369 5.63859 7.36091 5.73224C7.24814 5.82588 7.15733 5.94318 7.09492 6.07582C7.03251 6.20846 7.00002 6.35319 6.99975 6.49978H5.99976C5.99988 6.14703 6.0933 5.80059 6.27053 5.49561C6.44777 5.19062 6.70251 4.93793 7.00893 4.76317C7.31534 4.58842 7.66253 4.49781 8.01526 4.50055C8.368 4.50328 8.71374 4.59926 9.0174 4.77875C9.32107 4.95824 9.57187 5.21485 9.74435 5.52255C9.91683 5.83025 10.0049 6.1781 9.99952 6.5308C9.99417 6.88351 9.89564 7.22853 9.71391 7.53086C9.53218 7.83319 9.27372 8.08208 8.96475 8.25228C8.81712 8.34458 8.69642 8.47414 8.61478 8.62793C8.53315 8.78171 8.49348 8.95429 8.49975 9.12828V9.49978Z"
        fill="currentColor"
      />
      <path d="M8.49976 10.5H7.49976V11.5H8.49976V10.5Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_6546_26283">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
